import { getLocale } from '@/paraglide/runtime';

const BYTE_UNITS = [
  { unit: 'megabyte', bytes: 1024 ** 2 },
  { unit: 'kilobyte', bytes: 1024 },
  { unit: 'byte', bytes: 1 },
] as const;

export const formatBytes = (bytes: number) => {
  const { unit, bytes: unitBytes } =
    BYTE_UNITS.find((candidate) => bytes >= candidate.bytes) ?? BYTE_UNITS[2];
  return (bytes / unitBytes).toLocaleString(getLocale(), {
    style: 'unit',
    unit,
    maximumFractionDigits: 1,
  });
};
